import React from 'react';

class BlinkingMarker extends React.PureComponent {

    render() {
        const positionProps = ['left', 'right', 'top', 'bottom'];
        const keys = Object.keys(this.props);
        const styles = {}
        const { relative, size } = this.props

        for(let i = 0, length = keys.length; i < length; i++) {
            if(positionProps.indexOf(keys[i]) > -1) {
                styles[keys[i]] = this.props[keys[i]] + (relative ? '%' : 'px')
            }
        }

        if(size) {
            styles.width = `${size}px`
            styles.height = `${size}px`
        }

        return (
            <div
                className="BlinkingMarker"
                style={styles}>
            </div>
        )
    }
}

export default BlinkingMarker;